import { render } from "./FundacFees.vue?vue&type=template&id=8e60e138&ts=true"
import script from "./FundacFees.vue?vue&type=script&lang=ts"
export * from "./FundacFees.vue?vue&type=script&lang=ts"

import "./FundacFees.vue?vue&type=style&index=0&id=8e60e138&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__